<template>
  <v-bottom-navigation
    color="white"
    horizontal
    app
    background-color="primary"
  >
    <v-btn to="/users">
      <span>Users</span>
      <v-icon>mdi-account-supervisor</v-icon>
    </v-btn>
    <v-btn to="/schedules">
      <span>Schedules</span>
      <v-icon>mdi-calendar-month</v-icon>
    </v-btn>
    <v-btn @click.stop="profileToggle = !profileToggle">
      <span>Settings</span>
      <v-icon>mdi-cog-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        data () {
            return {
            }
        },
        computed: {
            ...mapGetters({
                profile: 'menu/profileDialog'
            }),
            profileToggle: {
                get() {
                    return this.profile
                },
                set(newValue) {
                    this.$store.commit('menu/SET_PROFILE_DIALOG', newValue)
                }
            },
        },
    }
</script>

<style lang="sass">
.v-bottom-navigation 
  button 
      span
          color: #fff

  .v-btn
    >.v-btn__content
      color: #fff
      
      .v-icon
        color: #fff
</style>